import React from "react";

interface SliderInputProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  helperText?: string;
}

export function SliderInput({
  label,
  value,
  min,
  max,
  step,
  onChange,
  helperText,
}: SliderInputProps) {
  return (
    <div className="slider-input">
      <div className="slider-header">
        <label className="slider-label">{label}</label>
        <span className="slider-value">{value}</span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="slider-range"
      />
      {helperText && <p className="slider-helper">{helperText}</p>}
    </div>
  );
}
